import type { Iteration } from '@gonfalon/experiments/types';
import { ExperimentStatusKind } from '@gonfalon/experiments/types';
import { msg } from '@gonfalon/messages/msg';

export function getExperimentExposuresChartEmptyState(
  iterationStatus: Iteration['status'] | undefined,
  isAnalyzingData = false,
): {
  emptyStateTitle: string;
  emptyStateSubtitle: string;
} {
  if (iterationStatus === ExperimentStatusKind.NOT_STARTED) {
    return {
      emptyStateTitle: msg('experiments.exposuresChart.emptyTitle'),
      emptyStateSubtitle: msg('experiments.exposuresChart.notStartedSubtitle'),
    };
  }

  if (isAnalyzingData) {
    return {
      emptyStateTitle: msg('experiments.exposuresChart.analyzingTitle'),
      emptyStateSubtitle: msg('experiments.exposuresChart.analyzingSubtitle'),
    };
  }

  return {
    emptyStateTitle: msg('experiments.exposuresChart.emptyTitle'),
    emptyStateSubtitle: '',
  };
}
